class TargetController {
  constructor() {
    this.name = 'target';
  }
}

export default TargetController;



// WEBPACK FOOTER //
// ./client/app/components/target/target.controller.js